import React, { ReactElement, useState } from 'react';
import AllergensToggleButton from '../components-library/menu/allergens/AllergensToggleButton';
import NutritionInfo from '../components-library/menu/allergens/NutritionInfo';

export interface AllergensContextInterface {
  isAllergensOpened: boolean;
  setIsAllergensOpened: (value: boolean) => void;
  toggleAllergensOpened: () => void;
  AllergensToggleButton: typeof AllergensToggleButton;
  NutritionInfo: typeof NutritionInfo;
}

export const AllergensContext = React.createContext<AllergensContextInterface>(null);

export default function AllergensProvider({ children }: { children: ReactElement }) {
  const [isAllergensOpened, setIsAllergensOpened] = useState(false);
  const toggleAllergensOpened = () => setIsAllergensOpened((current) => !current);

  const context = {
    isAllergensOpened,
    setIsAllergensOpened,
    toggleAllergensOpened,
    AllergensToggleButton,
    NutritionInfo,
  };

  return <AllergensContext.Provider value={context}>{children}</AllergensContext.Provider>;
}
